import React, { useCallback } from 'react';
import { StatusBar, StyleSheet, View } from 'react-native';
import { useSharedValue } from 'react-native-reanimated';

import { NativeStackScreenProps } from '@react-navigation/native-stack';

import { Box } from '@/components/lib/components';
import GradientBackground from '@/feature/promohub/components/GradientBackground';
import { PromoHeader } from '@/feature/promohub/components/PromoHeader';
import { usePromotions } from '@/feature/promohub/hooks/use-promotions';
import { useResumeEffect } from '@/hooks/use-resume';
import { PromohubStackParamList } from '@/navigation/types';

import { PromoDetailsContent } from '../components/PromoDetailsContent';
import { DEFAULT_PROMO_THEME, usePromoTheme } from '../hooks/use-promo-theme';

type ScreenProps = NativeStackScreenProps<PromohubStackParamList, 'PromoDetails'>;

const styles = StyleSheet.create({
    wrapper: {
        width: '100%',
        flex: 1,
    },
});

export const PromoDetails = (props: ScreenProps) => {
    const { promoId } = props.route.params;
    const { promotions, refetch } = usePromotions();
    const promotion = promotions.find(promo => promo.uid === promoId);
    const theme = promotion?.data.promo_theme.data ?? DEFAULT_PROMO_THEME;
    const { background_color } = usePromoTheme(theme);
    const headerHeight = useSharedValue(0);
    const scrollY = useSharedValue(0);

    const reload = useCallback(() => {
        refetch();
    }, [refetch]);

    useResumeEffect(reload);

    return (
        <Box flex={1}>
            <GradientBackground firstColor={background_color}>
                <StatusBar barStyle={'dark-content'} />
                <View style={styles.wrapper}>
                    <PromoHeader theme={theme} headerHeight={headerHeight} scrollY={scrollY} />
                    <PromoDetailsContent
                        theme={theme}
                        promoId={promoId}
                        scrollY={scrollY}
                        headerHeight={headerHeight}
                    />
                </View>
            </GradientBackground>
        </Box>
    );
};
